/**
 * Offer a time review from OUTSIDE any ticket card.
 *
 * A final Stop that completed its ticket cannot open the review on its own
 * card: the completed ticket leaves the technician's Dayboard on the next
 * refetch and the card's controls unmount with it. The Stop hands the episode
 * to the one app-level `TimerReviewHost` instead. Opening is a UX shortcut
 * only — the episode stays AWAITING_REVIEW until someone reviews it.
 */
export const OPEN_TIMER_REVIEW_EVENT = 'optibay:open-timer-review';

export function openTimerReviewOutsideCard(episodeId: string | null | undefined): void {
  if (!episodeId || typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OPEN_TIMER_REVIEW_EVENT, { detail: { episodeId } }));
}
